<template lang="pug">
  .white-fone
    p.title {{ (data.country || {}).name }}, {{(data.region || {}).name}},&nbsp;
      | {{((data.category || {}).name)}}, {{((data.sector || {}).name)}}{{((data.profession || {}).name || data.other_profession) ? ',' : ''}}
      | {{((data.profession || {}).name || data.other_profession)}}
    p.posted {{data.salary}} / {{salaryTypeName(data.salary_type, data.currency.code)}}
    p.posted {{ countryVisibilityChoices[data.country_visibility] }}
    p.posted {{ `${gettext('Posted')}:` }} {{ data.created_dt | dateNormalize }}

    .btn-get.top
      span
        .field.input-field
          input(
          :id="`publish_${data.id}`"
          type="checkbox"
          name="publish"
          class="switch is-outlined is-success"
          v-model="data.is_active"
          @click="activate()"
          )
          label(:for="`publish_${data.id}`") {{ data.is_active ? gettext('Published') : gettext('Not published') }}
    router-link.btn-response(
      :to="{name:'JobResponse', params:{lang: getLanguage, id: data.id}, query: {page: 1}}"
    )
      span(v-if="data.all_cvs_number") {{ data.all_cvs_number }}
      .btn-response-new(v-if="data.new_cvs_number") {{ data.new_cvs_number <= 100 ? data.new_cvs_number : '100+' }}
    .btn-get
      router-link.mdi.mdi-circle-edit-outline.icon-edit(:to="{name: 'EditJob', params: {lang: getLanguage, id: data.id}}")
      router-link.mdi.mdi-eye.icon-look(v-if="data.is_active" :to="{name: 'Vacancy', params: {lang: getLanguage, id: data.id}}")
      .mdi.mdi-delete-circle.icon-delete(@click="remove")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext, ngettext, interpolate } from '@/services/TranslateHandler'
import swal from 'sweetalert2'

const CONSTANTS = require('@/constants.json')

const moment = require('moment')
const toastr = require('toastr')

export default {
  name: 'JobPreview',
  props: {
    data: {
      default: () => {
        return {}
      }
    }
  },
  filters: {
    dateNormalize: function (date) {
      return moment(date).format('DD.MM.YYYY')
    }
  },
  methods: {
    gettext: gettext,
    ngettext: ngettext,
    interpolate: interpolate,
    ...mapActions([
      'getCountry',
      'employerActivateVacancy',
      'employerDeleteVacancy'
    ]),
    activate () {
      this.$nextTick(() => {
        this.employerActivateVacancy({id: this.data.id, active: this.data.is_active}).then(() => {
          toastr.success(gettext('Status changed'), gettext('Success!'))
        }).catch(() => {
          toastr.error(gettext('Status not changed'), gettext('Error!'))
        })
      })
    },
    remove () {
      swal({
        title: gettext('Are you sure?'),
        text: gettext('You won\'t be able to revert this!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: gettext('Yes, delete it!')
      }).then((result) => {
        if (result.value) {
          this.employerDeleteVacancy(this.data.id).then(() => {
            this.$emit('delete')
            toastr.success(gettext('Offer is deleted'), gettext('Success!'))
          }).catch(() => {
            toastr.error(gettext('Server error'), gettext('Error!'))
          })
        }
      })
    },
    salaryTypeName (code, currency) {
      if (!currency) currency = 'EUR'
      let types = {
        [CONSTANTS.SALARY_PER_HOUR]: interpolate(gettext('%(currency)s per hour'), [currency], true),
        [CONSTANTS.SALARY_PER_DAY]: interpolate(gettext('%(currency)s per day'), [currency], true),
        [CONSTANTS.SALARY_PER_WEEK]: interpolate(gettext('%(currency)s per week'), [currency], true),
        [CONSTANTS.SALARY_PER_MONTH]: interpolate(gettext('%(currency)s per month'), [currency], true)
      }
      if (code) return types[code]
      return types[CONSTANTS.SALARY_PER_HOUR]
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    countryVisibilityChoices () {
      return {
        10: this.gettext('All countries'),
        20: this.gettext('Local + EU countries'),
        30: this.gettext('Only from local country')
      }
    }
  }
}
</script>

<style lang='scss' scoped>
  .white-fone{
    position: relative;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    padding: 4rem 2rem;
    background-color: #fff;
  }
  .input-field{
    display: inline-block;
    margin: .5rem 0 0 2rem !important;
  }
  .img-wrap {
    margin-top: 0;
    width: 100%;
    height: calc(100% - 40px);
  }
  .btn-get {
    display: flex;
    width: 100%;
    justify-content: space-around;
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    color: #000;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.14px;
    padding: 10px 0;
    min-height: 50px;
    border-top: 1px solid #c7c7c7;
    &.top{
      justify-content: flex-start;
      top: 0;
      bottom: auto;
      border-top: none;
    }
  }
  .btn-response{
    position: absolute;
    right: 20px;
    top: 15px;
    cursor: pointer;
    color: #808080;
    font-weight: bold;
    display: flex;
    align-content: flex-end;
    align-items: flex-end;
    &-new{
      font-size: 10px;
      margin-left: 2px;
      color: #bb1d2c;
      position: absolute;
      background-color: #bb1d2c;
      border-radius: 10px;
      max-width: 26px;
      padding: 0 6px;
      display: flex;
      justify-content: center;
      color: white;
      top: 0px;
      right: -5px;
      transform: translate(50%, -50%);
    }
    &:hover{
      color: #bb1d2c;
    }
  }
  h3{
    font-size: 18px;
    font-weight: 300;
  }
  p{
    &.type{
      margin-bottom: 1rem;
      font-weight: 400;
    }
    &.title{
      font-weight: bold;
    }
  }
   .field{
     margin-top: 1rem;
     margin-bottom: .5rem;
     label{
       font-size: 14px;
     }
   }
</style>



// WEBPACK FOOTER //
// src/pages/profile/jobs/parts/job-preview/index.vue